import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../Containers/Config';
import { Constant } from '../../../../../Containers/Helpers/constant';
import { LIST_SURGE_RULES, LIST_SURGE_RULES_ERROR, LIST_SURGE_RULES_SUCCESS } from '../../../actionType';
import apiCall from '../../../apiCall';

function* getSurgeRules({ payload }) {
  console.log('payloaddd', payload);
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/list-rules`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: LIST_SURGE_RULES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: LIST_SURGE_RULES_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: LIST_SURGE_RULES_ERROR, payload: error });
  }
}

export function* watchGetSurgeRules() {
  yield takeEvery(LIST_SURGE_RULES, getSurgeRules);
}

function* getSurgeRulesSaga() {
  yield all([fork(watchGetSurgeRules)]);
}

export default getSurgeRulesSaga;
